import { GET_BOOKS } from 'modules/dashboard/store/constants';

export const getBooks = () => ({
  type: GET_BOOKS,
});
